import React from "react"
import * as styles from "./stat.module.scss"
import { fromPairs } from 'lodash'
import classNames from 'classnames';
import { useImage } from '../hooks/useImage'

export default function Stat(props) {
    console.log(props)
    const image = useImage(props.image)
    return (
        <div className={styles.stat}>
                <img className={styles.image} src={image.publicURL} />
 
            <div>
                <p className={styles.value}>{props.value}</p>
                <p className={styles.label}>{props.label}</p>
            </div>
        </div>
    )
}